import Api from '../helpers/Api';

export default class ReOrderRepository {
    constructor() {
        // Api fetch Reciever Data
        this.api = new Api();
    }

    /**
     * Post payload to Reorder
     * Redirect to E2 api
     * @param {*} payload
     * @returns
     */
    getReorderDataAsJsonAsync = async (payload) => {
        const result  = await this.api.postData('/api/myorders/reorder', payload);
        
        if(result.status === 200) {
            const reDirectLink = document.querySelector('#my-orders-template').getAttribute('data-reorder');
            window.location.replace(reDirectLink);
        }
    };
}
